<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   xmlns="http://www.w3.org/2000/svg"
   width="28.293367mm"
   height="22.28175mm"
   viewBox="0 0 28.293367 22.28175"
   version="1.1"
   id="fp-update">
  <g
     id="layer1"
     transform="translate(-35.268407,-185.41183)">
    <g
       id="g1319"
       style="fill:currentColor;fill-opacity:1;stroke:currentColor;stroke-opacity:1"
     >
      <path
         id="path1291"
         d="m 49.443863,185.53736 c -3.953918,0.006 -7.605516,2.10331 -9.583396,5.50509 l 1.805575,1.6521 c 1.470554,-2.93124 4.48152,-4.78551 7.777821,-4.78989 4.807009,-1.6e-4 8.703925,3.87177 8.70386,8.64805 -0.0024,0.0569 -0.0053,0.11372 -0.0088,0.17053 1.682804,1.06723 2.360157,2.06173 2.391069,-0.17053 1.6e-5,-6.08359 -4.963417,-11.01532 -11.086145,-11.01535 z m -11.086145,11.01535 c -1.6e-5,6.08359 4.963417,11.01532 11.086145,11.01535 3.952536,-0.006 7.603026,-2.10204 9.581327,-5.50199 l -1.804543,-1.65158 c -1.471405,2.9295 -4.481668,4.78219 -7.776784,4.78627 -4.806808,-1.2e-4 -8.703412,-3.87197 -8.703347,-8.64805 0.0022,-0.0551 0.005,-0.11027 0.0083,-0.16536 -1.088546,-2.53339 -2.333183,-0.86405 -2.391098,0.16536 z"
         style="opacity:1;fill:currentColor;fill-opacity:1;stroke:currentColor;stroke-width:0.25105041;stroke-opacity:1"/>
      <path
         id="path1298"
         d="m 35.592041,197.23732 7.784226,0.0167 -3.892113,-3.8253 z"
         style="opacity:1;fill:currentColor;fill-opacity:1;stroke:currentColor;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
      <path
         style="opacity:1;fill:currentColor;fill-opacity:1;stroke:currentColor;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
         d="m 55.453508,195.79854 7.784226,-0.0167 -3.892113,3.8253 z"
         id="path1300"/>
    </g>
  </g>
</svg>
